/*
 * Created by: cparaschiv
 * Date: 06.11.2014, 16:24 
 */

var SearchListProperty = TS.domain.properties.SearchListProperty = new Class(
    /** @lends TS.domain.properties.SearchListProperty# */
    {
        Extends: TS.domain.properties.SelectionListProperty,

        headerTemplate: null,
        template: null,
    });


SearchListProperty.mixin = function (target) {
    target.implement({
        afterInitialization: function (domain, config) {
            var me = this;

            me.parent(domain, config);
            if (config.headerTemplate) {
                me.headerTemplate = config.headerTemplate;
            }
            if (config.template) {
                me.template = config.template;
            }
        },

        getKendoTransportConfig: function () {
            var me = this,
                domain = me.Domain(),
                ret = me.parent();

            ret.sendKeyword = true;
            me.KeywordMember && (ret.keywordField = me.KeywordMember);
            ret.allowEmptySelection = false;

            return ret;
        },


        onSelectedItemChanged: function (newItem, raiseEvent, oldItem) {
            var me = this,
                domain = me.Domain(),
                editMember = ko.valueOf(me.EditMember),
                selectedItem = me.SelectedItem() || {};

            me.parent(newItem, raiseEvent, oldItem);
            ts.setPropertyValue(domain, editMember, selectedItem[me.ValueMember] || null);
        }
    });
};

SearchListProperty.mixin(SearchListProperty);

TS.ObjectFactory.map('SearchListProperty', TS.domain.properties.SearchListProperty);
